module.exports = __webpack_public_path__ + "img/jon_smith_4.410bf1a3.png";